export enum ReportGenerationType {
  Manual = 1,
  ESign,
}
